if (!customElements.get('stories-section')) {
  class StoriesSection extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
      this.desktopBreakpoint = 1024;
      this.handleResize = this.handleResize.bind(this);
    }

    connectedCallback() {
      this.handleResize();
      window.addEventListener('resize', this.handleResize);
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.handleResize);
      this.destroy();
    }

    get swiperContainer() {
      return this.querySelector('.stories-section__slider');
    }

    get paginationEl() {
      return this.querySelector('.swiper-pagination');
    }

    get prevButtonEl() {
      return this.querySelector('.swiper-button-prev');
    }

    get nextButtonEl() {
      return this.querySelector('.swiper-button-next');
    }

    getConfig() {
      return {
        slidesPerView: 1,
        slidesOffsetAfter: 12,
        slidesOffsetBefore: 12,
        spaceBetween: 12,
        centeredSlides: false,
        grabCursor: true,
        pagination: {
          el: this.paginationEl,
          type: 'fraction',
        },
        keyboard: {
          enabled: true,
        },
        breakpoints: {
          768: {
            slidesPerView: 2,
            slidesPerGroup: 1,
            spaceBetween: 20,
            slidesOffsetAfter: 20,
            slidesOffsetBefore: 20,
          },
        },
        navigation: {
          nextEl: this.nextButtonEl,
          prevEl: this.prevButtonEl,
        },
      };
    }

    handleResize() {
      const isDesktop = window.innerWidth >= this.desktopBreakpoint;

      if (isDesktop && this.swiper) {
        this.destroy();
      } else if (!isDesktop && !this.swiper) {
        this.init();
      }
    }

    init() {
      if (this.swiperContainer) {
        this.swiper = new Swiper(this.swiperContainer, this.getConfig());
      }
    }

    destroy() {
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    }
  }

  customElements.define('stories-section', StoriesSection);
}
